import {Typography} from "@mui/material";
import type {BasePlaces} from "../../firebase/index.js";
import PlaceLayout from "./PlaceLayout.jsx";


export interface PlaceListProps {
	  basePlaces: BasePlaces;
}


export default function PlaceList({basePlaces}: PlaceListProps) {
	  return (
				 <>
						{
							  Object.keys(basePlaces).length === 0 ?
										 <Typography variant="h4" sx={{textAlign: "center", marginTop: 4}}>No places found</Typography>
										 :
										 Object.entries(basePlaces).map(([key, place]) => (
													<PlaceLayout key={key} item={place}/>
										 ))
						}
				 </>
	  );
}
